declare global {
  interface Window {
    widgetToolsPublicPath?: string;
  }
}

if (window.widgetToolsPublicPath) {
  // @ts-ignore
  __webpack_public_path__ = window.widgetToolsPublicPath;
}

export {};
